import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import PostingsApi from '../../../../../API/shipment/postings-api.js';
import default_image from '../../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../../components/Basic/Blocks/index.js';
import { Button, CheckButton, SendButton } from '../../../../../components/Basic/Buttons/index.js';
import { DropDown, NavLink } from '../../../../../components/Basic/Elements/index.js';
import { Input, Select } from '../../../../../components/Basic/Inputs/index.js';
import { TableCell, TableLine } from '../../../../../components/Basic/Table/index.js';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle/index.js';
import { DIFF_STATUSES, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../../constans/index.js';
import { formFullDate, formFullDateWithSeconds, getDateMonth } from '../../../../../utils/index.js';
import CommentPostingProductBlock from '../../../../Shipments/Posting/CommentBlock/index.js';
import { WIDTH_POSTING } from '../index.js';
import styles from './styles.module.scss';

const STATE = {
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Собран', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const COLOR_MARKET = {
  wb: '#6c11c9',
  yandex: 'rgb(193 61 0)',
  ozon: 'rgb(19,79,231)',
  megamarket: 'rgb(13,131,25)',
  kuper: 'rgb(13,131,25)',
};

const ControlBuhLine = ({
  MODES,
  FILTER,
  tab,
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  loadData = () => { },
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  setOpenChzn = () => { },
  isMany = false,
  isDisabledPrint = () => { },
  onChangeProduct = () => { },
  isAdmin = false,

  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);
  const [openSklad, setOpenSklad] = useState({ state: false, product: {}, productProvider: {} });

  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_order = order.scan_time?.pick ? formFullDateWithSeconds(order.scan_time.pick) : null;
  const second_scan_time_order = order.scan_time?.packager ? formFullDateWithSeconds(order.scan_time.packager) : null;
  const sort_scan_time_order = order.scan_time?.sort ? formFullDateWithSeconds(order.scan_time.sort) : null;

  const is_disabled_print = isDisabledPrint(order);
  return (
    <>
      <TableLine
        key={order.market_order_number}
        style={order.is_printed && shipmentMode === MODES[0] ? { background: STATE['printed'].color } : {}}
      >
        {order.is_printed && <div className={styles.status_line} />}
        {shipmentMode === MODES[0] && (
          <TableCell width={WIDTH_POSTING[9]}>
            <CheckButton
              checked={postingsPrint[order.posting_number]}
              onSelect={() => changePostingPrint(order.posting_number)}
              disabled={is_disabled_print}
            />
          </TableCell>
        )}
        <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}{' '}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {isMany && (
              <NavLink
                to={TO_SHIPMENT(order.shipmentId)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '16px', width: 'auto', marginRight: '5px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            )}
            {order.market === 'wb' && (
              <>
                <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>
              </>
            )}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
          <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
            {scan_time_order} <br />
            {info && (
              <DropDown styles={styles.all_info} close={() => setInfo(false)}>
                <WhiteBlock styles={styles.init}>
                  <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                  <Text fontSize={18} fontWeight={600}>{`${order.scan_user.pick}`}</Text>
                  <div className={styles.scan_time}>({scan_time_order})</div>

                  {second_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.packager}`}</Text>
                      <div className={styles.scan_time}>
                        ({second_scan_time_order}){' '}
                        {order.scan_id.packager && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.packager}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {sort_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Сортировка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.sort}`}</Text>
                      <div className={styles.scan_time}>
                        ({sort_scan_time_order}){' '}
                        {order.scan_id.sort && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.sort}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </WhiteBlock>
              </DropDown>
            )}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[6]} center>
          <NavLink
            to={TO_SHIPMENT(order.shipment_id)}
            target={'_blank'}
            className={styles.scan_time}
            style={{ fontSize: '18px' }}
          >
            {getDateMonth(order.dates.shipment_date)}
          </NavLink>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`}>
                  <div key={k} className={styles.div_line_images}>
                    <div className={styles.wrapper}>
                      <img
                        onClick={() => openImageViewer(img)}
                        className={styles.preview}
                        src={img.length > 0 ? img[0] : undefined}
                      />
                    </div>
                    <Column>
                      <div className={styles.name}>
                        {`${p.ordered_quantity} x ${p.name}  `}
                        <span className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                          {p.offer_id}
                        </span>
                      </div>
                      {scan_time && (
                        <div className={styles.scan_time}>
                          {scan_time} {p.scan_user && `(${p.scan_user})`}
                        </div>
                      )}
                    </Column>
                    <CommentPostingProductBlock
                      isSmall={true}
                      posting={order}
                      offer_id={p.offer_id}
                      onChange={(v) => onChangeProduct(order.posting_number, p._id, 'comment', v)}
                      width="158px"
                    />
                  </div>
                </Column>
              );
            })}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[15]} center>
          <Column center>
            {order.products.map((p, k) => {
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`} style={{ alignItems: 'center' }}>
                  {getDateMonth(p.arrived_date || order.dates.shipment_date) || '?'}
                </Column>
              );
            })}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[15]} center>
          <Column center>
            {order.products.map((p, k) => {
              let d = order.history
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                .find(
                  (item) =>
                    item.field === 'shipment_diff' &&
                    ['Брак', 'Недостача', 'Пересорт'].includes(item.value) &&
                    ['Брак', 'Недостача', 'Пересорт'].includes(p.shipment_diff),
                )?.date;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`} style={{ alignItems: 'center' }}>
                  {getDateMonth(d)}
                </Column>
              );
            })}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[15]} center>
          <Column center>
            {order.products.map((p, k) => {
              let d = order.history
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                .find(
                  (item) =>
                    item.field === 'variance_status' &&
                    ['Оформлен'].includes(item.value)
                  // ['Оформлен'].includes(p.variance_process.status),
                )?.date;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`} style={{ alignItems: 'center' }}>
                  {getDateMonth(d) || ''}
                </Column>
              );
            })}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${order.posting_number}-${p.offer_id}-10`} style={{ width: '100%' }}>
              <Input
                width={'100%'}
                value={p.variance_process?.upd}
                // disabled={!isAdmin}
                // center
                onBlur={(v) => onChangeProduct(order.posting_number, p._id, 'variance_upd', v)}
              />
            </div>
          ))}

        </TableCell>
        <TableCell width={WIDTH_POSTING[11]} center={true}>
          <Column>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`${order.posting_number}-${p.offer_id}-10`} className={styles.div_line}>
                <Select
                  select={p.shipment_diff === 'Нет' ? null : p.shipment_diff}
                  list={DIFF_STATUSES}
                  style={{ fontSize: '16px' }}
                  width={'188px'}
                  disabled={true}
                  onSelect={(v) => onChangeProduct(order.posting_number, p._id, 'shipment_diff', v === 'Нет' ? '' : v)}
                  {...props}
                />
              </div>
            ))}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            {order.products.map((p, k) => (
              <div key={k} className={styles.div_line}>
                <Select
                  select={p.variance_process.status}
                  list={[
                    'Оформлен',
                    'Вычерк',
                    'Не заказывали',
                    'Согласовали',
                    'Не согласовали',
                    'Занесли на склад',
                    'Товар отгружен',
                    'Нет',
                  ]}
                  disabled={true}
                  style={{ fontSize: '16px' }}
                  width={'200px'}
                  onSelect={(v) =>
                    onChangeProduct(order.posting_number, p._id, 'variance_status', v === 'Нет' ? '' : v)
                  }
                  {...props}
                />
              </div>
            ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            {order.products
              // ?.filter((type) => type.category === 'Бухгалтерия')
              .map((p, k) => (
                <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                  <CommentPostingProductBlock
                    fieldFilter='variance_buh_approve'
                    posting={order}
                    offer_id={p.offer_id}
                    onChange={(v) => onChangeProduct(order.posting_number, p._id, 'variance_buh_approve', v)}
                    width={'230px'}
                  />
                </div>
              ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            {order.products
              ?.filter((p) => p.variance_process.status === 'Согласовали')
              .map((p, k) => (
                <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                  <SendButton
                    sendApi={PostingsApi.changeProductInPosting}
                    sendData={{
                      data: {
                        field: 'variance_approval',
                        postingNumber: order.posting_number,
                        productId: p._id
                      }
                    }}
                    endLoad={loadData}
                  >
                    Загрузить
                  </SendButton>

                  {p.variance_process.approval &&
                    <Button
                      style={{ marginLeft: '20px', width: '100px', fontSize: '17px' }}
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => PostingsApi.downloadPrivateFile({
                        data: {
                          field: 'buh_variance_approval',
                          postingNumber: order.posting_number,
                          productId: p._id
                        }
                      })}
                      disabled={!p.variance_process.approval}
                    >
                      {`${p.variance_process?.approval?.slice(p.variance_process?.approval?.lastIndexOf('.') + 1) || ''}`}
                    </Button>
                  }
                </div>
              ))}
          </Column>
        </TableCell>

        {isAdmin && (
          <>

            <TableCell width={WIDTH_POSTING[5]} center={true}>
              <Column>
                {order.products
                  ?.filter((p) => p.variance_process.status === 'Согласовали')
                  .map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        style={{ marginRight: '15px' }}
                        onClick={() => onChangeProduct(order.posting_number, p._id, 'variance_approval', 'delete')}
                        disabled={!p.variance_process.approval}
                      >
                        Удалить файл
                      </Button>
                    </div>
                  ))}
              </Column>
            </TableCell>

            <TableCell width={WIDTH_POSTING[5]} center={true}>
              <Column>
                {order.products
                  ?.filter((p) => p.variance_process.status === 'Согласовали')
                  .map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                      <Button
                        type={TYPE_BUTTONS.GREEN}
                        onClick={() => onChangeProduct(order.posting_number, p._id, 'variance_process_is_checked', !p.variance_process?.is_checked)}
                        disabled={!p.variance_process.approval && !p.variance_process?.is_checked}
                      >
                        {p.variance_process?.is_checked ? 'Достать из архива' : 'В архив'}
                      </Button>
                    </div>
                  ))}
              </Column>
            </TableCell>
          </>
        )}

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
    </>
  );
};

export default ControlBuhLine;
